import React, { Component } from 'react';

import { logActivity } from '_analytics/analytics-logger';
import { ACTIVITY_TYPES } from '_enums/activity-types';
import { PAGE_TYPES } from '_enums/page-types';

class M12Stubby extends Component {
  constructor() {
    super();

    this.state = {
      videoCanPlay: false,
      animateButton: false,
    };
  }

  componentDidMount() {
    this.buttonInterval = window.setInterval(() => {
      this.setState({
        animateButton: true,
      });
    }, 4000);
  }

  componentWillUnmount() {
    window.clearInterval(this.buttonInterval);
  }

  render() {
    return (
      <div className="thunderbolt__page stubby-wrench ">
        <div className="video-container">
          <div className="video-overlay"></div>
          <video className={`${this.state.videoCanPlay === true ? 'loaded' : ''}`} autoPlay loop muted playsInline onCanPlay={() => this.setState({ videoCanPlay: true })}>
            <source src={this.props.page.content.contentFields.videoBackground} type="video/mp4"></source>
          </video>
        </div>

        <div className="content-block">
          <a className={`thunderbolt-button thunderbolt-button--large ${this.state.animateButton ? 'animated' : ''}`} href={this.props.page.content.contentFields.buttonLink}
            target="_blank" rel="noopener noreferrer" onClick={e => this.handleProductClick(e)}>
            {this.props.page.content.contentFields.buttonText}
          </a>
        </div>
      </div>
    );
  }

  handleProductClick = (event) => {
    logActivity({
      activityType: ACTIVITY_TYPES.WRENCH_PRODUCT_VIEW,
      activityCulture: this.props.cultureCode,
      activityValue1: event.currentTarget.getAttribute('href'),
      activityValue2: PAGE_TYPES.M12_STUBBY_WRENCH,
    });
  }
}

export default M12Stubby;
